import { memo } from 'react';
import { LottieGif } from '@Sage/ssm-web5';
import { Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import metadata from 'lib/metadata';

const DanaBoxOption = () => {
    return (
        <div className="fm-ee__dana-box__generating">
            <LottieGif src={metadata.danaLoaderLottie} />
            <Text>{getLiteral('label_generating_response')}</Text>
        </div>
    );
};

export default memo(DanaBoxOption);
